import { Button, IconPlus } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import { default as IconKeyFilled } from '../../../assets/svg/icon_key_filled.svg';
import AddNewLicenseSystemToOrgModalContainer from './AddNewLicenseSystemToOrgModalContainer';

const AddNewLicenseSystemToOrgButton: FunctionComponent<{}> = () => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    return (
        <Button
            variant='primary'
            onClick={() => {
                context.onShowModal('inputModal', {
                    title: t('AddNewLicenseSystemToOrg.modal_title', 'Add new license system'),
                    titleIcon: <IconKeyFilled />,
                    content: <AddNewLicenseSystemToOrgModalContainer />,
                });
            }}
            icon={<IconPlus/>}
        >
            {t('AddNewLicenseSystemToOrg.button_title', 'Add new system')}
        </Button>
    );
};

export default AddNewLicenseSystemToOrgButton;